//Modules
import React, { useEffect, useState } from "react"
//Components
import SEO from "../components/SEO/SEO"
import DemoLessons from "../components/DemoLessons/DemoLessons"
//Live Contentful
import client from "../config/contentful"

const DemoLessonsPage = () => {
  const [lessons, setLessons] = useState([])

  useEffect(() => {
    client
      .getEntries({
        content_type: "demoLesson",
      })
      .then(res => {
        setLessons(res.items)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  return (
    <>
      <SEO title="Demo Lessons" description="Demo Lessons" />
      <DemoLessons lessons={lessons} />
    </>
  )
}

export default DemoLessonsPage
